export const doesWindowHaveBroadcastChannel = (): boolean => {
    return (
        typeof window !== 'undefined' && typeof BroadcastChannel !== 'undefined'
    )
}
